import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

const ResourceNotAvailable = () => {
    console.log("******** NOT AVAILABLE *******");
    return(
        <Box sx={{ display: 'flex' }} margin={{xs: 3}}>
            <Grid container spacing={5}>
                <Grid item xs={6}>
                    <p>Resursa cautata nu este disponibila...</p>
                </Grid>
            </Grid>
        </Box>        
    );
};

export default ResourceNotAvailable